import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    list: [],
    listLoading: false,
    selectedData: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedData(state, payload) {
      state.selectedData = payload;
    },
  },
  actions: {
    async loadAllByOutcomesIDAndYear({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get(
        "/sustainability/sources/scale/byOutcomesIDAndYear",
        {
          params: { id: payload.id, year: payload.year },
        }
      );
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadBySourceIDAndYear(
      { commit },
      { year: year, sourceId: sourceId }
    ) {
      commit("setListLoading", true);
      let list = await api.get(
        "/sustainability/sources/scale/bySourceIDAndYear",
        {
          params: { id: sourceId, year: year },
        }
      );
      commit("setSelectedData", list.data[0]);
      commit("setListLoading", false);
    },
    async loadAllByOutcomesIDAndYearWithGoals({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get(
        "/sustainability/sources/scale/byOutcomesIDAndYearWithGoals",
        {
          params: { id: payload.id, year: payload.year },
        }
      );
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadBySourceID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("/sustainability/sources/scale/bySourceID", {
        params: { id: id },
      });
      commit("setSelectedData", list.data[0]);
      commit("setListLoading", false);
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("/sustainability/sources/scale", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: {
                Message: "There was an Error, Please try again later",
              },
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedData(state) {
      return state.selectedData;
    },
  },
};
